<template>
    <div class="row">

        <div class="col-lg-8 col-lg-offset-2 col-xs-12">
            <CreditInfo v-if="renderInfo" />
        </div>

        <div class="col-lg-8 col-lg-offset-2 col-xs-12">
            <DragAndDrop v-on:showCreditmodal="updateInfo($event)" />
        </div>

        <div class="col-lg-10 col-lg-offset-1 col-xs-12">
            <UploadLeadsTable />
        </div>

    </div>
</template>

<script>

import CreditInfo from '@/components/CreditInfo.vue'
import DragAndDrop from '@/components/DragAndDrop.vue'
import UploadLeadsTable from '@/components/UploadLeadsTable.vue'

export default {
  name: 'upload_leads',
  components: {
    CreditInfo,
    DragAndDrop,
    UploadLeadsTable
  },
  mounted () {
    this.messageStorage.destroyAll()
  },
  data () {
    return {
      messageStorage: this.flash(),
      renderInfo: true
    }
  },
  methods: {
    updateInfo () {
      this.renderInfo = false
      this.$nextTick(() => {
        this.renderInfo = true
      })
    }
  }
}
</script>

<style lang="scss">

</style>
